var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { AwesomeEvent, ComponentAPI } from '@philips-internal/oswald-ui-core';
import { ChangeEvent, ChangeEventListener } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
import { executeGrecaptcha } from './recaptcha-utils.js';
class RecaptchaAPI extends ComponentAPI {
    constructor() {
        super(...arguments);
        /** @event */
        this.onChange = new ChangeEventListener();
    }
    /**
     * Gets the recaptcha checkbox alignment.
     */
    getAlignment() {
        return this.state.alignment;
    }
    /**
     * Sets the recaptcha checkbox alignment.
     *
     * @param alignment - The recaptcha checkbox alignment.
     */
    setAlignment(alignment) {
        this.setState({ alignment });
    }
    /**
     * Returns if the recaptcha is enabled.
     */
    isEnabled() {
        return this.state.enabled;
    }
    /**
     * Sets if the recaptcha is enabled.
     *
     * @param enabled - If the recaptcha is enabled.
     */
    setEnabled(enabled) {
        this.setState({ enabled });
    }
    /**
     * Programmatically invokes the reCAPTCHA check and generates a new valid token if the check succeeds
     * This method triggers the onChange event as the mount execution also does
     */
    execute() {
        const { siteKey, version, value: oldValue } = this.state;
        const updateResponse = (response) => {
            this.setState({ response });
            this.onChange.fire(new ChangeEvent({ oldValue, value: response }));
        };
        const onExpireCallback = () => {
            if (!window.grecaptcha) {
                return;
            }
            window.grecaptcha.reset();
            updateResponse('');
        };
        executeGrecaptcha({
            onExpireCallback,
            onLoadCallback: updateResponse,
            siteKey,
            version,
        });
    }
    /**
     * Gets the recaptcha site key.
     */
    getSiteKey() {
        return this.state.siteKey;
    }
    /**
     * Sets the recaptcha site key.
     *
     * @param siteKey - The recaptcha site key.
     */
    setSiteKey(siteKey) {
        this.setState({ siteKey });
    }
    /**
     * Gets the recaptcha checkbox size.
     */
    getSize() {
        return this.state.size;
    }
    /**
     * Sets the recaptcha checkbox size.
     *
     * @param size - The recaptcha checkbox size.
     */
    setSize(size) {
        this.setState({ size });
    }
    /**
     * Gets the recaptcha checkbox tabindex.
     */
    getTabIndex() {
        return this.state.tabIndex;
    }
    /**
     * Sets the recaptcha checkbox tabindex.
     *
     * @param tabIndex - The recaptcha checkbox tabindex.
     */
    setTabindex(tabIndex) {
        this.setState({ tabIndex });
    }
    /**
     * Gets the recaptcha checkbox theme.
     */
    getTheme() {
        return this.state.theme;
    }
    /**
     * Sets the recaptcha checkbox theme.
     *
     * @param theme - The recaptcha checkbox theme.
     */
    setTheme(theme) {
        this.setState({ theme });
    }
    /**
     * Gets the recaptcha checkbox type.
     */
    getType() {
        return this.state.type;
    }
    /**
     * Sets the recaptcha checkbox type.
     *
     * @param type - The recaptcha checkbox type.
     */
    setType(type) {
        this.setState({ type });
    }
    /**
     * Gets the recaptcha token value.
     */
    getValue() {
        return this.state.response;
    }
    /**
     * This is not a valid method, it is just here to comply with Component API typings
     */
    setValue() {
        throw new Error('[Recaptcha API]: Value must not be externally changed');
    }
    /**
     * Gets the recaptcha site key.
     */
    getVersion() {
        return this.state.version;
    }
    /**
     * Sets the recaptcha site key.
     *
     * @param version - The recaptcha site key.
     */
    setVersion(version) {
        this.setState({ version });
    }
}
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], RecaptchaAPI.prototype, "onChange", void 0);
export { RecaptchaAPI, };
//# sourceMappingURL=recaptcha-api.js.map